import styled from 'styled-components';

export const StyledDescription = styled.p`
  font-size: 16px;
  padding: 0 10px 10px;
  border-bottom: 1px solid ${({ theme }) => theme.color.borderColor};
  margin-bottom: 10px;
  white-space: pre-line;
`;
